import { Component } from 'preact';
import ReplayShareCard, { replayMetaFromHistory } from './ReplayShareCard';
import { GOLD, ACCENT_GOLD, TEXT_PRIMARY, TEXT_MUTED } from '../lib/medievalTheme';
import { t } from '../localization/t';

// One match_history row as the card a shared replay draws in a DM, off the
// same metadata. Rename and pin ride on top as overlays rather than inside
// it: a button cannot contain buttons. The tools only mount with an
// `onUpdateMatchMeta`, which the owner's lists pass and a visitor's do not.
export default class ReplayHistoryCard extends Component {
  state = { renaming: false, draft: '' };

  _commitRename() {
    this.props.onUpdateMatchMeta?.(this.props.match.roomCode, { name: this.state.draft });
    this.setState({ renaming: false, draft: '' });
  }

  render() {
    const { match: m, profile, sorceryCards, canWatch = true, onWatch, onUpdateMatchMeta } = this.props;
    const { renaming, draft } = this.state;
    return (
      <div className="group relative">
        <ReplayShareCard
          meta={replayMetaFromHistory(m, profile)}
          sorceryCards={sorceryCards}
          canWatch={canWatch && !renaming}
          onWatch={onWatch}
        />
        {m.roomCode && onUpdateMatchMeta ? (
          <div className="absolute top-1 right-1 flex items-center gap-0.5">
            <button
              type="button"
              title={t('Rename')}
              className="flex items-center justify-center opacity-0 group-hover:opacity-60 hover:!opacity-100 transition-opacity cursor-pointer rounded"
              style={{ width: '1.125cqw', height: '1.125cqw', background: 'transparent', border: 'none', color: TEXT_MUTED }}
              onClick={() => this.setState({ renaming: true, draft: m.customName || '' })}
            >
              <svg style={{ width: '0.6875cqw', height: '0.6875cqw' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z" /></svg>
            </button>
            <button
              type="button"
              title={m.pinned ? t('Unpin') : t('Pin to top')}
              className={`flex items-center justify-center transition-opacity cursor-pointer rounded ${m.pinned ? 'opacity-90' : 'opacity-0 group-hover:opacity-60 hover:!opacity-100'}`}
              style={{ width: '1.125cqw', height: '1.125cqw', background: 'transparent', border: 'none', color: m.pinned ? ACCENT_GOLD : TEXT_MUTED }}
              onClick={() => onUpdateMatchMeta(m.roomCode, { pinned: !m.pinned })}
            >
              <svg style={{ width: '0.75cqw', height: '0.75cqw' }} viewBox="0 0 24 24" fill={m.pinned ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"><path d="M6 3h12v18l-6-4.5L6 21z" /></svg>
            </button>
          </div>
        ) : null}
        {renaming ? (
          <input
            type="text"
            value={draft}
            autoFocus
            maxLength={60}
            placeholder={t('vs {name}', { name: m.opponentName || t('Opponent') })}
            className="absolute px-1.5 py-0.5 rounded text-[0.6875cqw] outline-none"
            style={{
              left: '0.75cqw', right: '0.75cqw', top: '0.5cqw',
              background: 'rgba(0,0,0,0.85)', border: `1px solid ${GOLD} 0.4)`, color: TEXT_PRIMARY,
            }}
            onInput={(e) => this.setState({ draft: e.currentTarget.value })}
            onKeyDown={(e) => {
              if (e.key === 'Enter') this._commitRename();
              if (e.key === 'Escape') this.setState({ renaming: false, draft: '' });
            }}
            onBlur={() => this._commitRename()}
          />
        ) : null}
      </div>
    );
  }
}
